import React from 'react';

import { IDaysRange } from 'detailsv2/structure';

import { DaysRange, TSingleDayPicker, TRangeDayPicker, TProps } from './types';

type TSinglePicker = {
  selected?: number | null;
  onSelect: (date?: number | null) => void;
} & Pick<TSingleDayPicker, 'mode'>;

type TRangePicker = {
  selected?: IDaysRange | null;
  onSelect: (range?: IDaysRange) => void;
} & Omit<TRangeDayPicker, 'selected' | 'onSelect' | 'required'>;

export const withDayResolver = (WrappedComponent: React.ComponentType<TProps>) => {
  return (props: TSinglePicker | TRangePicker) => {
    if (props.mode === 'range') {
      const selected = { from: props.selected?.start || undefined, to: props.selected?.end || undefined };
      const onSelect = (daysRange: DaysRange) => props.onSelect({ start: daysRange.from!, end: daysRange.to || null });

      return <WrappedComponent {...props} selected={selected} onSelect={onSelect} />;
    }

    const selected = props.selected || undefined;
    const onSelect = (day?: number) => props.onSelect(day);
    return <WrappedComponent {...props} selected={selected} onSelect={onSelect} />;
  };
};
